namespace HA.Core.Service {
    export interface IWebPageService {
        isActive: (d: any) => boolean;
        reloadApp: (d?: any) => void;
        removeApp: (d: any) => void;
        removeCurrentApp:() => void;
        reloadNav:() => void;
        reloadPreviousApp:() => void;
        replaceAppId: (id: any, newId: any) => void;
        setMainApp: (d: any) => void;
        showApp: (d: any) => void;
        showAppMenu: (id: any) => void;
        showModal: (id: any) => void;
        showFSApp: (d: any) => void;
        showPreviousApp: () => void;
        toggleQMenu: () => void;
        setQMenu: (qmenu: () => void) => void;
        subscribeToAppInfo: (func: (info: Map<string, any>) => void) => string[];
        unsubscribeToAppInfo: (subscriptionId: string) => void;
        toggleApp: (d: any) => void;
    }

    export class Service extends HA.HAObject {
    }
}
